export default __webpack_public_path__ + "static/media/blux_logo_large_white_bg.01b0573d.png";